// extracted by mini-css-extract-plugin
module.exports = {"blog_list":"blog-list-module--blog_list--bKQ4U","no_posts":"blog-list-module--no_posts--2S4IA","blog_wrapper_mobile_style":"blog-list-module--blog_wrapper_mobile_style--1UPFQ"};